import React, { type FC } from 'react'
import { Flex, Typography } from 'antd'

import { WppErrorIcon } from './icons'

const { Title, Text } = Typography

const defaultMessage = 'Something has gone wrong. Please contact an administrator.'

interface ILayoutErrorComponentProps {
  message?: string
}

export const WppLayoutErrorPlaceholder: FC<ILayoutErrorComponentProps> = ({ message = defaultMessage }) => (
  <Flex vertical={true} align='center'>
    <WppErrorIcon />
    <Title level={4}>Error</Title>
    <Text>{message}</Text>
  </Flex>
)
